Ext.define('SA.ViewController', {
    extend: 'Ext.util.Observable',

    constructor(model) {
        this.callParent();

        this.model = model;
        this.projectViews = new SA.ProjectViewsByMode();
    },

    destroy() {
        this.model = null;

        SA.ProjectViewToolbar.remove(this.toolbar);

        this.projectViews.destroy();

        this.clearListeners();
    },

    getEditControllerParams() {
        var activeState = new SA.ActiveState();

        this.on('setModeActive:edit', active => activeState.setActive(active));

        return {model: this.model, activeState};
    },

    getModel() {
        return this.model;
    },

    getOrCreateViewForMode(mode) {
        if (!this.projectViews.has(mode)) {
            let view = mode === 'edit' ? this.createEditView() : this.createDefaultView();

            this.projectViews.set(mode, view);
        }

        return this.projectViews.get(mode);
    },

    isActive() {
        return SA.AppController.isActiveController(this);
    },

    isEditMode() {
        return this.mode === 'edit';
    },

    refreshModeIndicator() {
        SA.HistoricalModeIndicator.maybeShow(this.model);
    },

    setModeActive(mode, active) {
        if (active) {
            this.showView(mode);
        }

        this.fireEvent('setModeActive', {mode, active});
        this.fireEvent(`setModeActive:${mode}`, active);
    },

    showView(mode) {
        this.mode = mode;

        SA.ProjectView.show(this.getOrCreateViewForMode(mode));

        SA.PageHeader.set({model: this.model, mode});
        SA.ProjectViewToolbar.setToolbar(mode === 'edit' ? null : this.toolbar);
        SA.ViewChooser.set({model: this.model, mode});

        this.refreshModeIndicator();
    }
});